/**
 * Hebrew/Arabic report HTML: force block layout to RTL so Latin-only
 * labels (e.g. T12-L1 headings) sit on the right with the rest of the report.
 */

/**
 * @param {string} language
 * @returns {boolean}
 */
export function isRtlUiLanguage(language) {
  const code = String(language || "")
    .toLowerCase()
    .split(/[-_]/)[0];
  return code === "he" || code === "ar";
}

/**
 * Flip explicit LTR / left-align markers in report HTML.
 * Regex-based so it works in Node tests and the browser (no DOMParser).
 * @param {string} html
 * @returns {string}
 */
export function normalizeRtlReportHtml(html) {
  if (!html || typeof html !== "string") return html;

  return html
    .replace(/\bdir\s*=\s*(["']?)ltr\1/gi, 'dir="rtl"')
    .replace(/text-align\s*:\s*left/gi, "text-align: right")
    .replace(/\btext-left\b/g, "text-right");
}

/**
 * @param {string} html
 * @param {string} language
 * @returns {string}
 */
export function prepareReportHtmlForLanguage(html, language) {
  if (!isRtlUiLanguage(language)) return html;
  return normalizeRtlReportHtml(html);
}
